import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { CheckBox } from '@winelidays/wld-tsx-2/fields';
const OptInEstablishmentField = (t0) => {
    const $ = _c(9);
    let establishmentName;
    let props;
    if ($[0] !== t0) {
        ({ establishmentName, ...props } = t0);
        $[0] = t0;
        $[1] = establishmentName;
        $[2] = props;
    }
    else {
        establishmentName = $[1];
        props = $[2];
    }
    const translate = useTranslate();
    let t1;
    if ($[3] !== establishmentName || $[4] !== translate) {
        t1 = translate("form.opt_in.specific_establishment", { establishmentName });
        $[3] = establishmentName;
        $[4] = translate;
        $[5] = t1;
    }
    else {
        t1 = $[5];
    }
    const label = t1;
    let t2;
    if ($[6] !== label || $[7] !== props) {
        t2 = <CheckBox id="opt-in-establishments" label={label} {...props}/>;
        $[6] = label;
        $[7] = props;
        $[8] = t2;
    }
    else {
        t2 = $[8];
    }
    return t2;
};
export default OptInEstablishmentField;
